import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Box, Typography } from "@mui/material";
import { color, Grid, useTheme } from "@mui/system";
import { useIsMobile } from "pages/landing";
import LandingLayout from "components/landing/LandingLayout";
import { useEffect } from "react";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const isMobile = useIsMobile();
  const theme = useTheme();

  return (
    <LandingLayout>
      <Box sx={{ padding: "5.625vw 3.125vw" }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography fontSize={15} color="#848484" fontWeight={600}>
            ABOUT US
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontSize: "72px",
              color: "#0A0A0A",
              lineHeight: 1.2,
            }}
            //   fontSize: "clamp(45px, 4.21875vw - 9px, 72px)",
            fontWeight={"600"}
            mt={5}
          >
            Changing the Way <br />
            <span
              style={{
                fontSize: "72px",
                backgroundImage: "url('/images/australia-flag.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Australia
            </span>{" "}
            Borrows
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: "20px", marginTop: "1rem", color: "#474747" }}
            fontWeight={"normal"}
            lineHeight={"30px"}
          >
            At EZIFIN, we’re on a mission to make finance simple, fast, and
            transparent—so you <br />
            can focus on growth, not red tape.
          </Typography>
          <Box
            sx={{
              width: "100%",
              justifyItems: "center",
              textAlign: "center",
              marginTop: "2rem",
            }}
          >
            <DotLottieReact
              src="/images/contact-us.lottie"
              loop
              autoplay
              style={{
                width: isMobile ? "100%" : "75vw",
                background: "#F2F6FF",
                borderRadius: "24px",
              }}
            />
          </Box>
        </Box>
      </Box>

      {/* Images Grid */}
      <Box sx={{ padding: "5.625vw 3.125vw" }}>
        <Box>
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, md: 6 }} sx={{ textAlign: "right" }}>
              <Box sx={{ textAlign: "center" }}>
                <img
                  src="/images/couple-team.png"
                  style={{
                    width: isMobile ? "100%" : "39.063vw",
                    marginRight: "2rem",
                  }}
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} sx={{ alignContent: "center" }}>
              <Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <img src="/images/couple-team.gif" width={80} />
                  <Typography fontSize={48} color="#0A0A0A" fontWeight={600}>
                    Our Vision
                  </Typography>
                </Box>
                <Typography fontSize={20} color="#474747" lineHeight={"30px"}>
                  To be Australia’s most trusted lending provider, empowering{" "}
                  <br />
                  individuals and businesses with flexible and innovative <br />
                  financial solutions that drive long-term success.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/* Second */}
      <Box sx={{ padding: "5.625vw 3.125vw" }}>
        <Box>
          <Grid container spacing={4}>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{ justifyItems: "right", alignContent: "center" }}
              order={{ xs: 2, md: 1 }}
            >
              <Box sx={{ paddingRight: "2rem" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <img src="/images/trophy.gif" width={80} />
                  <Typography
                    fontSize={48}
                    color="#0A0A0A"
                    fontWeight={600}
                    sx={{
                      lineHeight: "72px",
                      [theme.breakpoints.down("md")]: {
                        lineHeight: "normal",
                        marginTop: "1rem",
                      },
                    }}
                  >
                    Our Mission
                  </Typography>
                </Box>
                <Typography
                  fontSize={20}
                  color="#474747"
                  lineHeight={"30px"}
                  sx={{
                    [theme.breakpoints.down("md")]: {
                      marginTop: "1rem",
                    },
                  }}
                >
                  To redefine the future of lending in Australia by delivering{" "}
                  <br />
                  bold, accessible, and innovative financial solutions that{" "}
                  <br />
                  empower individuals and businesses to grow with <br />
                  confidence.
                </Typography>
              </Box>
            </Grid>

            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{ alignContent: "center" }}
              order={{ xs: 1, md: 2 }}
            >
              <Box
                sx={{
                  maxWidth: "31.25rem",
                  maxHeight: "450px",
                  overflow: "hidden",
                  borderRadius: "24px",
                  height: "450px",
                }}
              >
                <img
                  src="/images/festival.jpg"
                  style={{
                    width: isMobile ? "100%" : "39.063vw",
                    borderRadius: "24px",
                    transform: isMobile ? "scale(2.2)" : "scale(1.5)",
                    position: "relative",
                    top: isMobile ? "7rem" : "5rem",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <img
        src="/images/line-contact-us.png"
        style={{
          width: "100%",
          transform: isMobile ? "scale(1.5)" : "scale(1.11)",
          position: "relative",
          left: isMobile ? "18.5vw" : "1.5vw",
          top: isMobile ? "-9.5vw" : "-2.5vw",
        }}
      />

      {/* Third */}
      <Box sx={{ padding: "5.625vw 3.125vw" }}>
        <Box>
          <Grid container spacing={4}>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{ textAlign: "right", justifyItems: "right" }}
            >
              <Box
                sx={{
                  maxWidth: "31.25rem",
                  maxHeight: "450px",
                  overflow: "hidden",
                  borderRadius: "24px",
                  height: "450px",
                  position: "relative",
                  right: isMobile ? 0 : "2rem",
                }}
              >
                <img
                  src="/images/real-solution.jpg"
                  style={{
                    width: isMobile ? "100%" : "39.063vw",
                    borderRadius: "24px",
                    transform: isMobile ? "scale(2.4)" : "scale(1.8)",
                    position: "relative",
                    top: isMobile ? "8rem" : "4rem",
                  }}
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} sx={{ alignContent: "center" }}>
              <Box
                sx={{
                  [theme.breakpoints.down("md")]: {
                    marginTop: "2rem",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    fontSize={48}
                    color="#0A0A0A"
                    fontWeight={600}
                    sx={{ lineHeight: "72px" }}
                  >
                    From{" "}
                    <img
                      src="/images/pig.svg"
                      style={{
                        background: "#E0D0DA33",
                        padding: "6px 1.375rem",
                        borderRadius: "50px",
                        position: "relative",
                        top: "1rem",
                      }}
                    />{" "}
                    Red Tape to Real Solutions
                  </Typography>
                </Box>
                <Typography
                  fontSize={20}
                  color="#474747"
                  lineHeight={"30px"}
                  sx={{
                    [theme.breakpoints.down("md")]: {
                      marginTop: "1rem",
                    },
                  }}
                >
                  Founded in 2018, EZIFIN was created to cut through outdated{" "}
                  <br />
                  processes and make lending fast, flexible, and transparent{" "}
                  <br />
                  for borrowers everywhere.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* Fourth */}
      <Box sx={{ padding: "5.625vw 3.125vw" }}>
        <Box>
          <Grid container spacing={4}>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                justifyItems: "right",
                alignContent: "center",
                paddingLeft: "24px",
              }}
              order={isMobile ? { xs: 2, md: 1 } : {}}
            >
              <Box sx={{ paddingRight: "2rem" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    fontSize={48}
                    color="#0A0A0A"
                    fontWeight={600}
                    lineHeight={"72px"}
                    sx={{
                      [theme.breakpoints.down("md")]: {
                        lineHeight: "normal",
                      },
                    }}
                  >
                    Feel the EZIFIN Difference
                  </Typography>
                </Box>
                <Typography
                  fontSize={20}
                  color="#474747"
                  lineHeight={"30px"}
                  sx={{
                    [theme.breakpoints.down("md")]: {
                      marginTop: "1rem",
                    },
                  }}
                >
                  We believe lending should be a win-win. That’s why our <br />
                  approach is built on clarity, speed, and trust.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} sx={{ alignContent: "center" }}>
              <Box
                sx={{
                  maxWidth: "31.25rem",
                  maxHeight: "450px",
                  overflow: "hidden",
                  borderRadius: "24px",
                  height: "450px",
                }}
              >
                <img
                  src="/images/ezifin-team.png"
                  style={{
                    width: isMobile ? "100%" : "39.063vw",
                    borderRadius: "24px",
                    transform: isMobile ? "scale(2)" : "scale(1.5)",
                    position: "relative",
                    top: isMobile ? "6rem" : "5rem",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box sx={{ padding: "5.625vw 3.125vw" }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: "48px",
              color: "black",
              [theme.breakpoints.down("md")]: {
                marginTop: "2rem",
              },
            }}
            //   fontSize: "clamp(45px, 4.21875vw - 9px, 72px)",
            fontWeight={"600"}
            lineHeight={"normal"}
          >
            Our <span style={{ color: "#0053FD" }}>values</span> guide our
            decisions
          </Typography>

          <Grid container spacing={4} mt={"4rem"}>
            <Grid
              size={{ xs: 6, md: 3 }}
              sx={{
                background: "#FE994E26",
                borderRadius: "16px",
                padding: "1.875vw",
              }}
            >
              <Box
                sx={{
                  textAlign: "left",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "22px",
                    lineHeight: "28px",
                  }}
                >
                  Fast When It <br />
                  Matters
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "17px",
                    lineHeight: "22px",
                  }}
                  mt={"1rem"}
                >
                  Access approvals quickly, so you never miss an opportunity.
                </Typography>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <img
                  src="/images/law-money.svg"
                  style={{ margin: "2rem 0", width: "80%" }}
                />
              </Box>
            </Grid>

            {/* Second */}
            <Grid
              size={{ xs: 6, md: 3 }}
              sx={{
                background: "#775CCF26",
                borderRadius: "16px",
                padding: "1.875vw",
              }}
            >
              <Box
                sx={{
                  textAlign: "left",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "22px",
                    lineHeight: "28px",
                  }}
                >
                  Flexible On Your Terms
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "17px",
                    lineHeight: "22px",
                  }}
                  mt={"1rem"}
                >
                  Tailored loan options that adapt to your goals and
                  circumstances.
                </Typography>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <img
                  src="/images/deal-terms.svg"
                  style={{ margin: "2rem 0", width: "100%" }}
                />
              </Box>
            </Grid>

            {/* Third */}
            <Grid
              size={{ xs: 6, md: 3 }}
              sx={{
                background: "#E5E5E5",
                borderRadius: "16px",
                padding: "1.875vw",
              }}
            >
              <Box
                sx={{
                  textAlign: "left",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "22px",
                    lineHeight: "28px",
                  }}
                >
                  Transparent At Every Step
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "17px",
                    lineHeight: "22px",
                  }}
                  mt={"1rem"}
                >
                  Clear terms, no hidden fees—so you know exactly where you
                  stand.
                </Typography>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <img
                  src="/images/transparent-money.svg"
                  style={{ margin: "2rem 0", width: "80%" }}
                />
              </Box>
            </Grid>

            {/* Fourth */}
            <Grid
              size={{ xs: 6, md: 3 }}
              sx={{
                background: "#5FD08F26",
                borderRadius: "16px",
                padding: "1.875vw",
              }}
            >
              <Box
                sx={{
                  textAlign: "left",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "22px",
                    lineHeight: "28px",
                  }}
                >
                  Support Beyond Lending
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "17px",
                    lineHeight: "22px",
                  }}
                  mt={"1rem"}
                >
                  A dedicated team focused on your success, every step of the
                  way.
                </Typography>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <img
                  src="/images/money-graph.svg"
                  style={{ margin: "2rem 0", width: "80%" }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </LandingLayout>
  );
};

export default AboutUs;
